import React, { useEffect, useState } from 'react'
import { Table, Typography, Button, Modal, Form, Input, Select, DatePicker, message, Popconfirm, Tag, Empty } from 'antd'
import { PlusOutlined, DeleteOutlined, CheckOutlined } from '@ant-design/icons'
import { goalsAPI, clientsAPI } from '../services/api'
import dayjs from 'dayjs'

const { Title, Text } = Typography

function Objetivos() {
  const [goals, setGoals] = useState([])
  const [clients, setClients] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => { load(); loadClients() }, [])

  const load = async () => {
    try {
      const res = await goalsAPI.getAll()
      setGoals(res.data)
    } catch (e) { message.error('Error cargando objetivos') }
  }

  const loadClients = async () => {
    try {
      const res = await clientsAPI.getAll()
      setClients(res.data)
    } catch (e) {}
  }

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      await goalsAPI.create({
        clientId: values.clientId,
        title: values.title,
        targetDate: values.targetDate ? values.targetDate.format('YYYY-MM-DD') : null,
        notes: values.notes
      })
      message.success('Objetivo creado')
      setModalVisible(false)
      form.resetFields()
      load()
    } catch (e) { message.error('Error creando objetivo') }
  }

  const handleToggle = async (goal) => {
    try {
      await goalsAPI.update(goal.id, { status: goal.status === 'achieved' ? 'pending' : 'achieved' })
      load()
    } catch (e) { message.error('Error') }
  }

  const handleDelete = async (id) => {
    try {
      await goalsAPI.remove(id)
      message.success('Objetivo eliminado')
      load()
    } catch (e) { message.error('Error') }
  }

  const columns = [
    { title: 'Objetivo', dataIndex: 'title', render: (v, r) => (
      <Text strong delete={r.status === 'achieved'} style={{ color: r.status === 'achieved' ? '#52c41a' : undefined }}>{v}</Text>
    )},
    { title: 'Alumna', dataIndex: 'Client', ellipsis: true, render: (c) => c ? `${c.name} ${c.lastName}` : 'N/A' },
    { title: 'Fecha objetivo', dataIndex: 'targetDate', responsive: ['md'], render: (d) => d ? dayjs(d).format('DD/MM/YY') : '—' },
    { title: 'Estado', dataIndex: 'status', width: 90, render: (s) => s === 'achieved' ? <Tag color="green">Logrado</Tag> : <Tag color="orange">Pendiente</Tag> },
    { title: 'Acciones', key: 'actions', width: 90, render: (_, r) => (
      <span>
        <Button size="small" type="text" icon={<CheckOutlined style={{ color: r.status === 'achieved' ? '#999' : '#52c41a' }} />} onClick={() => handleToggle(r)} />
        <Popconfirm title="¿Eliminar objetivo?" onConfirm={() => handleDelete(r.id)}>
          <Button size="small" type="text" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </span>
    )}
  ]

  return (
    <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
        <Title level={4} style={{ margin: 0 }}>Objetivos</Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => { form.resetFields(); setModalVisible(true) }}>
          Nuevo Objetivo
        </Button>
      </div>
      <Text style={{ display: 'block', marginBottom: 12, color: '#999' }}>
        Metas y objetivos de cada alumna. Las alumnas los ven en su portal.
      </Text>

      <div style={{ overflowX: 'auto' }}>
        <Table
          dataSource={goals}
          columns={columns}
          rowKey="id"
          size="small"
          scroll={{ x: 480 }}
          pagination={{ pageSize: 15, size: 'small' }}
          locale={{ emptyText: <Empty description="Todavía no hay objetivos" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
        />
      </div>

      <Modal title="Nuevo Objetivo" open={modalVisible} onOk={handleSubmit} onCancel={() => setModalVisible(false)} okText="Crear" width={480}>
        <Form form={form} layout="vertical" size="small">
          <Form.Item name="clientId" label="Alumna" rules={[{ required: true, message: 'Elegí la alumna' }]}>
            <Select
              showSearch
              placeholder="Buscar alumna..."
              optionFilterProp="children"
              filterOption={(input, option) => (option.children || '').toString().toLowerCase().includes(input.toLowerCase())}
            >
              {clients.map(c => <Select.Option key={c.id} value={c.id}>{c.name} {c.lastName}</Select.Option>)}
            </Select>
          </Form.Item>
          <Form.Item name="title" label="Objetivo" rules={[{ required: true, message: 'Describí el objetivo' }]}>
            <Input placeholder="Ej: Bajar 3kg, Correr 5km sin parar" />
          </Form.Item>
          <Form.Item name="targetDate" label="Fecha objetivo">
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="notes" label="Notas">
            <Input.TextArea rows={2} placeholder="Detalles..." />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default Objetivos
